module.exports = (__webpack_require__(7))(463);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webstomp-client/dist/webstomp.js from dll-reference vendor
// module id = 1233
// module chunks = 0